import {
  DEMO_UPDATE_SCORE,
  DEMO_UPDATE_NAME,
  DEMO_UPDATE_TAG,
  DEMO_SAVE,
  DEMO_SAVE_SUCCESS,
  DEMO_SAVE_FAIL,
  DEMO_RESET
} from './constants';
export const updateDemoScore = (attribute, value) => ({
  type: DEMO_UPDATE_SCORE, attribute, value
});
export const updateDemoName = name => ({
  type: DEMO_UPDATE_NAME, name
});
export const updateDemoTag = tag => ({
  type: DEMO_UPDATE_TAG, tag
});
export const saveDemoAnimal = animal => ({
  type: DEMO_SAVE, animal
});
export const saveDemoAnimalSuccess = animal => ({
  type: DEMO_SAVE_SUCCESS, animal
});
export const saveDemoAnimalFail = error => ({
  type: DEMO_SAVE_FAIL, error
});
export const demoReset = () => ({
  type: DEMO_RESET
});
